import { render } from "./HeroFigure.vue?vue&type=template&id=368c310d&scoped=true"
import script from "./HeroFigure.vue?vue&type=script&lang=js"
export * from "./HeroFigure.vue?vue&type=script&lang=js"

import "./HeroFigure.vue?vue&type=style&index=0&id=368c310d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368c310d"]])

export default __exports__